import engagement from './engagement.svg';
import weddings from './weddings.svg';
import prewedding from './pre-weddings.svg';
import proposals from './proposals.svg';
import corporate from './corporate.svg';
import celebrations from './celebrations.svg';


const Services = [
	{
	id: 1,
	name: 'Engagements',
	description: 'A beautiful tapestry where cultures converge and diversity becomes a course for celebration. We specialize in capturing traditional weddings and understand the importance of preserving cultural heritage.',
	image: engagement,

},
{
	id: 2,
	name: 'Weddings',
	description: 'Weddings hold a special place in our hearts as they embody the epitome of elegance and romance. With a keen eye for beauty, we create videos that capture the essence of love and celebration.',
	image: weddings,
},
{
	id: 3,
	name: 'Pre-wedding',
	description: 'By capturing genuine emotions, candid moments, and heartfelt interactions, we create videos that reflect core of our celebration and the depth of your connections.',
	image: prewedding,
},
{
	id: 4,
	name: 'Proposals',
	description: 'Capture the magic of your wedding proposal with our exceptional videography services. Our team of skilled videographers will ensure that every precious moment is beautifully documented, from the nervous anticipation to the heartfelt "Yes!"',
	image: proposals,

},
{
	id: 5,
	name: 'Corporate Events',
	description: `In today's fast-paced and competitive corporate world, companies are constantly seeking innovative ways to capture and convey the essence of their events. AllIsWell provides an effective and engaging media to showcase the highlights, atmosphere, and key messages of corporate events.`,
	image: corporate,

},
{
	id: 6,
	name: 'Celebrations',
	description: `Our team of skilled videographers are experts at capturing the essence of each celebration, ensuring that no precious moment goes unnoticed. We understand the desire to preserve these special moments and share them with friends and family, which is why we go above and beyond to deliver high-quality videos.`,
	image: celebrations,
}
]

export default Services;
